import { render, staticRenderFns } from "./studentsBillMapping.vue?vue&type=template&id=9ea56ddc&scoped=true"
import script from "./studentsBillMapping.vue?vue&type=script&lang=js"
export * from "./studentsBillMapping.vue?vue&type=script&lang=js"
import style0 from "./studentsBillMapping.vue?vue&type=style&index=0&id=9ea56ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea56ddc",
  null
  
)

export default component.exports